import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_jvwej64k6r: FaireCollectionEntity = {
  token: "pbc_jvwej64k6r",
  type: "collection",
  name: "Pumpkin🍁🎃",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d0d2da586cf35a01a79dcb0b860fdbe1d78e342a7c0a1445276fc2ddb972c002.jpeg",
  itemCount: 59,
  description:
    "Hey Pumpkin! This collection is bringing the Fall fun -- the perfect outfits for all of your Autumn Adventures.",
  brandToken: "b_gro99lye",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:26:37.287Z",
    importedBy: "entity-db-import-collections",
  },
};
